import { Component, OnInit } from '@angular/core';
import AOS from 'aos';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    AOS.init();
    const animateCard = document.getElementById('tuvo-hero-card');
    setTimeout(() => {
      
      animateCard.classList.add('slideLeft');
    }, 1000);
  }

  openNav() {
    const hamburger = document.querySelector('.hamburger');
    const body = document.querySelector('body');
    // const menu = document.querySelector('.menu');
    const mainWrapper = document.querySelector('.container-wrapper');
    const sideMenu = document.querySelector('.sideMenu_div');
    const closeBtn = document.querySelector('.close_btn');
    hamburger.classList.add('animate');
    // body.style.backgroundColor = 'red';ppack
    mainWrapper.classList.add('shiftMain');
    sideMenu.classList.add('shiftSide');
    // mainWrapper.classList.toggle('sideMenu_div');
  }
  
  closeNav() {
    
    const mainWrapper = document.querySelector('.container-wrapper');
    const sideMenu = document.querySelector('.sideMenu_div');
    const closeBtn = document.querySelector('.close_btn');
    const body = document.querySelector('body');
    // menu.classList.toggle('hideMenu');
    // mainWrapper.classList.add('returnMain');
    mainWrapper.classList.remove('shiftMain');
    body.classList.remove('bodybg');
//     sideMenu.classList.add('returnSide');
    sideMenu.classList.remove('shiftSide');
  }


}
